"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParamFromLocationSearch = exports.getParamsFromQueryString = void 0;

var getParamsFromQueryString = function getParamsFromQueryString(locationInstance) {
  if (locationInstance.length === 0) return {};
  var locationSearch = {};
  var params = locationInstance.slice(1);
  var splittedParams = params.split("&");
  splittedParams.forEach(function (element) {
    var value = element.split("=");
    locationSearch[value[0]] = decodeURIComponent(value[1]);
  });
  return locationSearch;
};

exports.getParamsFromQueryString = getParamsFromQueryString;

var getParamFromLocationSearch = function getParamFromLocationSearch(name, locationInstance) {
  var params = getParamsFromQueryString(locationInstance.search);
  return params[name] || "";
};

exports.getParamFromLocationSearch = getParamFromLocationSearch;